export {default as translateLocale} from "./src/dictionaries/translateLocale.js";
export {default as formatLocale} from "./src/dictionaries/formatLocale.js";
export {default as locale} from "./src/dictionaries/timeLocale.js";

export {default as findLocale} from "./src/findLocale.js";

export type {TranslationStrings} from "./src/dictionaries/translateLocale.js";
export type {FormatLocaleDefinition} from "./src/dictionaries/formatLocale.js";
export type {TimeLocaleDefinition} from "./src/dictionaries/timeLocale.js";
